import type { MessageKey } from "./ru"

export const hyMessages = {
  "common.loading": "Բեռնում...",
  "common.error": "Սխալ",
  "common.back": "Հետ",
  "common.next": "Հաջորդ",
  "common.search": "Որոնում",
  "auth.loginErrorTitle": "Մուտքի սխալ",
  "auth.openViaTelegram": "Բացեք հավելվածը Telegram-ի միջոցով",
  "auth.telegramRequired": "Հավելվածը պետք է բացվի Telegram-ի միջոցով",
  "auth.authorizationError": "Նույնականացման սխալ",
  "device.rotatePortrait": "Պտտեք սարքը ուղղահայաց դիրքի",
  "country.brazil": "Բրազիլիա",
  "country.vietnam": "Վիետնամ",
  "country.egypt": "Եգիպտոս",
  "country.india": "Հնդկաստան",
  "country.indonesia": "Ինդոնեզիա",
  "country.iran": "Իրան",
  "country.spain": "Իսպանիա",
  "country.italy": "Իտալիա",
  "country.kazakhstan": "Ղազախստան",
  "country.colombia": "Կոլումբիա",
  "country.malaysia": "Մալայզիա",
  "country.mexico": "Մեքսիկա",
  "country.nigeria": "Նիգերիա",
  "country.pakistan": "Պակիստան",
  "country.russia": "Ռուսաստան",
  "country.usa": "ԱՄՆ",
  "country.turkey": "Թուրքիա",
  "country.uzbekistan": "Ուզբեկստան",
  "country.ukraine": "Ուկրաինա",
  "country.philippines": "Ֆիլիպիններ",
  "countrySelection.chooseCountry": "Ընտրեք երկիրը",
  "countrySelection.openAria": "Ընտրել երկիրը",
  "languageSelection.chooseLanguage": "Ընտրեք լեզուն",
  "commercial.direction.autotrade": "Ավտոշուկա",
  "commercial.direction.insurance": "Ապահովագրություն",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Ճանապարհային օգնություն",
  "commercial.searchLabel": "BeepApp որոնում",
  "commercial.cityPlaceholder": "Մուտքագրեք քաղաքը",
  "commercial.emptyTitle": "Այսօր առաջարկներ չկան",
  "commercial.emptyLine1": "Ձեր քաղաքում դեռ ակտիվ BeepApp գործընկերներ չկան",
  "commercial.emptyLine2": "Մենք արդեն աշխատում ենք նրանց գտնելու և միացնելու ուղղությամբ",
  "commercial.emptyLine3": "Նոր առաջարկները այստեղ կհայտնվեն ավտոմատ",
  "commercial.helperLine1": "Մուտքագրեք ձեր քաղաքը՝ տեսնելու",
  "commercial.helperLine2": "հասանելի առաջարկները",
  "commercial.partnerPrompt": "Ցանկանո՞ւմ եք դառնալ BeepApp-ի գործընկեր",
  "commercial.apply": "Դիմել",
  "main.admin": "Ադմին",
  "main.garage": "Ավտոտնակ",
  "main.signalSent": "Ազդանշանն ուղարկված է",
  "main.partnerInviteUnavailable": "Գործընկերային հրավերն անհասանելի է",
  "main.enterPlate": "Մուտքագրեք պետհամարանիշը",
  "main.searchError": "Որոնման սխալ",
  "main.signalSendError": "Չհաջողվեց ուղարկել ազդանշանը",
  "main.shareCardPrefix": "Համարանիշի քարտ",
  "main.shareLinkError": "Չհաջողվեց պատրաստել հղումը",
  "main.searchByPlateAria": "Որոնում ըստ պետհամարանիշի",
  "main.russianPlateAria": "Ռուսական պետհամարանիշ",
  "main.plateAria": "Պետհամարանիշ",
  "main.findPlateAria": "Գտնել համարանիշը",
  "main.loadingVehicle": "Համարանիշի քարտը բեռնվում է…",
  "main.leaveSignal": "Ուղարկել ազդանշան",
  "main.share": "Կիսվել",
  "signalSelection.chooseType": "Ընտրեք ազդանշանի տեսակը",
  "signalSelection.category.attention": "Անձնական",
  "signalSelection.category.road": "Ճանապարհային",
  "signalSelection.category.urgent": "Շտապ",
  "signalSelection.chooseSignal": "Ընտրեք ազդանշանը",
  "signalSelection.suggestOwn": "Առաջարկել ձեր տարբերակը",
  "signalConfirmation.title": "Հաստատեք ազդանշանը",
  "signalConfirmation.plateHeading": "Ստուգեք պետհամարանիշը",
  "signalConfirmation.signalHeading": "Ստուգեք ընտրված ազդանշանը",
  "signalConfirmation.replyTitle": "Թույլատրել պատասխան Telegram-ում",
  "signalConfirmation.replyBody": "Միացրեք սա, որպեսզի համարանիշի սեփականատերը կարողանա\nգրել ձեզ Telegram-ում։ Պատասխան հնարավոր է միայն, եթե\nունեք @username։ Պատասխանելու որոշումը մնում է\nհամարանիշի սեփականատիրոջը։",
  "signalConfirmation.consentText": "Հաստատում եմ, որ այս ազդանշանը համապատասխանում է\nիրական իրավիճակին և սպամ չէ\nկամ կեղծ հաղորդում։",
  "signalConfirmation.warning": "Ուղարկելուց հետո ազդանշանը\nհնարավոր չէ փոխել",
  "signalConfirmation.sending": "Ուղարկվում է…",
  "signalConfirmation.send": "Ուղարկել",
  "partner.loadingAria": "Բեռնում",
  "partner.title": "Գործընկերային ծրագիր",
  "partner.offerLine1": "Ստացեք 30% բոլոր վճարումներից անժամկետ",
  "partner.offerLine2": "ձեր կողմից BeepApp հրավիրված օգտատերերից",
  "partner.offerLine3": "Telegram-ի գործընկերային ծրագրի միջոցով",
  "partner.connectUnavailable": "Միացումը հասանելի կլինի Telegram Affiliate Program-ը կարգավորելուց հետո։",
  "partner.connectTelegram": "Միացնել Telegram-ում",
  "partner.qrAria": "Գործընկերային հղման QR կոդ",
  "partner.download": "Ներբեռնել",
  "partner.promoHeading": "Ստեղծեք անձնական պրոմոկոդ",
  "partner.promoHelperLine1": "Պրոմոկոդը ակտիվացնում է բաժանորդագրության լրացուցիչ մեկ տարի",
  "partner.promoHelperLine2": "և օգնում է ներգրավել օգտատերերի",
  "partner.promoAria": "Պրոմոկոդ",
  "partner.affiliateHeading": "Ձեր գործընկերային հղումը",
  "partner.affiliateHelper": "Պահպանեք հղումը՝ անձնական QR կոդ ստեղծելու համար",
  "partner.affiliateAria": "Գործընկերային հղում",
  "partner.qrNoteLine1": "QR կոդը կարելի է տեղադրել ձեր մեքենայի վրա,",
  "partner.qrNoteLine2": "սոցիալական ցանցերում և գովազդային նյութերում",
  "partner.save": "Պահպանել",
  "partner.reset": "Վերակայել",
  "partner.resetConfirm": "Վերակայե՞լ պահպանված գործընկերային հղումը։ Պրոմոկոդը կմնա ձերը։",
  "partner.promoFormatError": "Պրոմոկոդը պետք է պարունակի 4-ից 15 նիշ։",
  "partner.affiliateHostError": "Թույլատրվում են միայն t.me կամ telegram.me հղումներ։",
  "partner.affiliatePathError": "Հղումը չի պարունակում Telegram ուղի։",
  "partner.affiliateFormatError": "Սխալ գործընկերային հղում։",
  "partner.loadError": "Բեռնման սխալ",
  "partner.checkInputError": "Ստուգեք մուտքագրված տվյալները",
  "garageActivation.promoInvalid": "Պրոմոկոդը անվավեր է",
  "garageActivation.plateOccupied": "Այս պետհամարանիշն արդեն կապված է",
  "garageActivation.activateError": "Չհաջողվեց ակտիվացնել Ավտոտնակը",
  "garageEntry.loadJournalError": "Չհաջողվեց բեռնել մատյանը",
  "garageEntry.loadStatusesError": "Չհաջողվեց բեռնել կարգավիճակները",
  "garageEntry.activationSuccess": "Ավտոտնակը հաջողությամբ ակտիվացվեց",
  "garageEntry.plateAttached": "Համարանիշը կապված է",
  "garageEntry.attachError": "Չհաջողվեց կապել համարանիշը",
  "garageEntry.activationNote": "Ակտիվացրեք ձեր Ավտոտնակը",
  "garageSheet.activationTitle": "Ավտոտնակի ակտիվացում",
  "garageSheet.plateHelper": "Մուտքագրեք մեքենայի պետհամարանիշը",
  "garageSheet.promoHelper": "Ունե՞ք պրոմոկոդ",
  "garageSheet.cleanBonusLine1": "Ակտիվացումից հետո կունենաք 1 ժամ",
  "garageSheet.cleanBonusLine2": "անվճար «Մաքուր մեկնարկի» համար",
  "garageSheet.activationFor": "Ակտիվացում՝",
  "garageSheet.cost": "Արժեք",
  "garageSheet.ownerConsentLine1": "Հաստատում եմ, որ ես սեփականատերն եմ",
  "garageSheet.ownerConsentLine2": "նշված պետհամարանիշով",
  "garageSheet.ownerConsentLine3": "տրանսպորտային միջոցի։",
  "garageSheet.processing": "Մշակում...",
  "garageSheet.attach": "Կապել",
  "garageSheet.pay": "Վճարել",
  "garageLifecycle.cleanTitle": "Մաքուր մեկնարկ",
  "garageLifecycle.deactivateTitle": "Ավտոտնակի ապաակտիվացում",
  "garageLifecycle.cleanWarningLine1": "Համարանիշի պատմությունը կջնջվի",
  "garageLifecycle.cleanWarningLine2": "առանց վերականգնման հնարավորության։",
  "garageLifecycle.deactivateWarningLine1": "Ապաակտիվացումից հետո ակտիվ",
  "garageLifecycle.deactivateWarningLine2": "Ավտոտնակի գործառույթները հասանելի չեն լինի",
  "garageLifecycle.willBeDeleted": "ԿՋՆՋՎԻ",
  "garageLifecycle.cleanRemovedLine1": "• Մատյանի բոլոր գրառումները",
  "garageLifecycle.cleanRemovedLine2": "• Ստացված ազդանշանների պատմությունը",
  "garageLifecycle.cleanRemovedLine3": "• Ազդանշանների հանրային հաշվիչները",
  "garageLifecycle.cleanRemovedLine4": "  համարանիշի քարտում",
  "garageLifecycle.willRemain": "ԿՄՆԱ",
  "garageLifecycle.cleanPreservedLine1": "• Համարանիշի կապը Ավտոտնակի հետ",
  "garageLifecycle.cleanPreservedLine2": "• Ակտիվացման մնացած ժամկետը",
  "garageLifecycle.cleanPreservedLine3": "• Ընտրված համարանիշի կարգավիճակը",
  "garageLifecycle.cleanPreservedLine4": "• Համարանիշի քարտի ընդհանուր դիտումների քանակը",
  "garageLifecycle.freeFirstHour": "Անվճար առաջին ժամվա ընթացքում",
  "garageLifecycle.willBecomeUnavailable": "ԿԴԱՌՆԱ ԱՆՀԱՍԱՆԵԼԻ",
  "garageLifecycle.deactivateRemovedLine1": "• Մատյան",
  "garageLifecycle.deactivateRemovedLine2": "• Համարանիշի կարգավիճակի ընտրություն և օգտագործում",
  "garageLifecycle.deactivateRemovedLine3": "• Դուք ավտոմատ կլքեք AutoClan-ը",
  "garageLifecycle.deactivateRemovedLine4": "• Ավտոշուկա",
  "garageLifecycle.deactivateRemovedLine5": "• Ապահովագրություն",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Ճանապարհային օգնություն",
  "garageLifecycle.deactivateRemovedLine8": "• Պետհամարանիշը կանջատվի Ավտոտնակից",
  "garageLifecycle.willRemainAvailable": "ԿՄՆԱ ՀԱՍԱՆԵԼԻ",
  "garageLifecycle.deactivatePreservedLine1": "• Ուղեկից",
  "garageLifecycle.deactivatePreservedLine2": "• Դիսպետչեր",
  "garageLifecycle.deactivatePreservedLine3": "• Պետհամարանիշի որոնում և դիտում",
  "garageLifecycle.deactivatePreservedLine4": "  մեքենայի հանրային քարտը",
  "garageLifecycle.deactivatePreservedLine5": "• Կրկին ակտիվացնելու հնարավորություն",
  "garageLifecycle.deactivatePreservedLine6": "  Ավտոտնակը ցանկացած պահի",
  "garageLifecycle.cleanConsentLine1": "Հաստատում եմ այս համարանիշի",
  "garageLifecycle.cleanConsentLine2": "ամբողջ պատմությունը ջնջելու համաձայնությունը",
  "garageLifecycle.cleanConsentLine3": "առանց վերականգնման հնարավորության։",
  "garageLifecycle.deactivateConsentLine1": "Հաստատում եմ ապաակտիվացումը և",
  "garageLifecycle.deactivateConsentLine2": "բոլոր ակտիվ Ավտոտնակի գործառույթների",
  "garageLifecycle.deactivateConsentLine3": "հասանելիության դադարեցումը։",
  "garageLifecycle.clean": "Մաքրել",
  "garageLifecycle.deactivate": "Ապաակտիվացնել",
} satisfies Record<MessageKey, string>
